import { HttpAction } from "@megaron/http-service";

const pushGoogleMerchantsProducts = HttpAction({
  path: "/googleMerchants/pushProducts",
  method: "post",
  requiresAuth: true,
});

export const googleMerchantsActions = {
  pushGoogleMerchantsProducts,
};
